import * as util from '../util';

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  const len = typeof rule.len === 'number';
  const min = typeof rule.min === 'number';
  const max = typeof rule.max === 'number';
  // æ­£åå¹éç ç¹èå´ä»U+010000ä¸ç´å°U+10FFFFçæå­ï¼è¡¥åå¹³é¢Supplementary Planeï¼
  const spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  let val = value;
  let key = null;
  const num = typeof value === 'number';
  const str = typeof value === 'string';
  const arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // å¤çç ç¹å¤§äºU+010000çæå­lengthå±æ§ä¸åç¡®çbugï¼å¦"ð ®·ð ®·ð ®·".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(
        util.format(options.messages[key].len, rule.fullField, rule.len),
      );
    }
  } else if (min && !max && val < rule.min) {
    errors.push(
      util.format(options.messages[key].min, rule.fullField, rule.min),
    );
  } else if (max && !min && val > rule.max) {
    errors.push(
      util.format(options.messages[key].max, rule.fullField, rule.max),
    );
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(
      util.format(
        options.messages[key].range,
        rule.fullField,
        rule.min,
        rule.max,
      ),
    );
  }
}

export default range;
